"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _MiniDropDown = _interopRequireDefault(require("./MiniDropDown"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "button": "multi_action_button-module__button___qJQwB",
  "desktop": "multi_action_button-module__desktop___9lvLz",
  "icon": "multi_action_button-module__icon___uwEV8",
  "disabled": "multi_action_button-module__disabled___Tuu5Y",
  "text": "multi_action_button-module__text___DUyR_",
  "options": "multi_action_button-module__options___PRkWe"
};
const DROPDOWN_PADDING = 18;
const DROPDOWN_OPTION_HEIGHT_DESKTOP = 24;
const DROPDOWN_OPTION_HEIGHT_OTHER = 40;
class MultiActionButton extends _react.default.Component {
  static propTypes = {
    className: T.string,
    displayId: T.string,
    displayString: T.string,
    dropdownClassName: T.string,
    actions: T.arrayOf(T.shape({
      displayId: T.string,
      displayString: T.string,
      onClick: T.func,
      tracking: T.shape({
        element: T.string,
        action: T.string,
        page: T.string
      })
    })),
    disabled: T.bool,
    position: T.oneOf(['above', 'below']),
    bottomOffset: T.number // represents a distance between component and parent
  };

  static defaultProps = {
    position: 'below',
    screenWidth: 'desktop',
    displayId: 'au.actions'
  };
  handleOnClick(tracking, onClick, event) {
    if (tracking) {
      _AuAnalytics.default.trackEvent({
        category: tracking.element || "DropDownElement",
        action: tracking.action,
        label: tracking.page
      });
    }

    // Call actual onClick
    onClick && onClick(event);
  }
  actionsWithTracking = (0, _bind.default)(_context = this.actionsWithTracking).call(_context, this);
  actionsWithTracking(actions) {
    return (0, _map.default)(actions).call(actions, action => {
      if (action.tracking) {
        var _context2;
        action.onClick = (0, _bind.default)(_context2 = this.handleOnClick).call(_context2, this, action.tracking, action.onClick);
      }
      delete action.tracking;
      return action;
    });
  }
  render() {
    const {
      disabled,
      actions,
      screenWidth,
      bottomOffset
    } = this.props;
    const {
      className,
      displayId,
      displayString
    } = this.props;
    if (!actions || !actions.length) {
      return false;
    }
    const isDesktop = screenWidth === 'desktop';
    let position = this.props.position;
    if (!disabled && typeof bottomOffset !== 'undefined') {
      let optionHeight = isDesktop ? DROPDOWN_OPTION_HEIGHT_DESKTOP : DROPDOWN_OPTION_HEIGHT_OTHER;
      let minHeight = actions.length * optionHeight + DROPDOWN_PADDING;
      position = minHeight <= bottomOffset ? 'below' : 'above';
    }
    return /*#__PURE__*/_react.default.createElement(_MiniDropDown.default, {
      type: isDesktop ? 'caret' : 'more',
      position: position,
      options: this.actionsWithTracking(actions),
      disabled: disabled,
      className: (0, _classnames.default)(styles.button, {
        [styles.disabled]: disabled,
        [styles.desktop]: isDesktop
      }, className),
      iconClassName: styles.icon,
      optionsClassName: styles.options,
      textClassName: styles.text,
      displayId: isDesktop ? displayId : '',
      displayString: isDesktop ? displayString : ''
    });
  }
}
exports.default = MultiActionButton;